<template>
<div>
  <ol class="ml-10">
    <li v-for="f in fileListDisplay" :key="f.id" class="mt-10">
      <el-button v-if="isImage(f.fileRepo.name)" type="text" 
      	@click="showImage(f.fileRepo.uuid)"> ({{f.fileNote}}) {{f.fileRepo.name}}
      </el-button>
      <p style="display:inline-block;" v-else>({{f.fileNote}}) <a :href="displayAvatar(f.fileRepo.uuid)" target=_new>
      	{{f.fileRepo.name}}
      </a></p>

      <el-popconfirm
        class="ml-10 popconfirm-bg"
        title="確定刪除此筆附件嗎?"
        confirm-button-text="確定"
        cancel-button-text="取消刪除"
        icon="el-iconf-info"
        icon-color="red"
        @confirm="deleteFile(f.id)">
        <el-button v-if="canEdit" type="text" slot="reference" ><i class="el-icon-error"></i> 刪除</el-button>
      </el-popconfirm>
    </li>
  </ol>

  <el-dialog title="附件圖"
           :visible.sync="img.dialog"
           :width="dw">
    <div class="demo-image">
      <el-image
        style="width: 100%; max-width: 100%; height: 100%;"
        :src="img.url"
        fit="cover" lazy>
          <div slot="placeholder" class="image-slot">
              <i class="el-icon-loading"></i> 開啟中...
            </div>
        </el-image>
    </div>
 </el-dialog>

</div>
</template>

<script>

export default {
  name: "TaskAttachment",
  props: ['fileListDisplay', 'dw', 'canEdit', 'loadHistoryData'],
  data() {
    return {
      img:{
        dialog: false,
        url:''
      }
    }
  },
  methods: {

  	showImage(uuid) {
      this.img.dialog = true
      this.img.url = this.displayAvatar(uuid)
    },

    
    deleteFile(id) {
      this.request.delete("/todo/emp/history/file/" + id).then(res => {
        if (res.code === '200') {
          
          //call parent's loadHistoryData
          this.loadHistoryData()

          this.showResult('success', '附件刪除成功.')
        } else {
          this.showResult('error', '附件刪除失敗.')
        }
      })
    },
   
  },
  mounted() {
  }
}

</script>

<style scoped>

</style>
